import { render, staticRenderFns } from "./trashIcon.vue?vue&type=template&id=67e0ee2c&"
import script from "./trashIcon.vue?vue&type=script&lang=js&"
export * from "./trashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports